import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer 
      className="border-t border-[#D4AF37]/20 pt-16 pb-8"
      style={{
        background: 'linear-gradient(180deg, #0a0a0a 0%, #1a1405 50%, #0d0b06 100%)'
      }}
      data-testid="footer"
    >
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img 
              src="/images/goldnote-logo.png" 
              alt="Goldnote" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-white/50 text-sm font-light leading-relaxed mb-4">
              Redefining precious metal ownership through innovation, security, and timeless design.
            </p>
            <p className="text-[#D4AF37]/60 text-xs tracking-wider">
              U.S. Patent No. 10,668,765
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">About</Link></li>
              <li><Link to="/products" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Products</Link></li>
              <li><Link to="/corporate" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Corporate Notes</Link></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-4">Support</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Contact Us</a></li>
              <li><a href="#" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">FAQs</a></li>
              <li><a href="#" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Authenticity Verification</a></li>
              <li><a href="#" className="text-white/50 text-sm hover:text-[#D4AF37] transition-colors">Shipping & Returns</a></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="text-white/50 text-sm">info@goldnote.com</li>
              <li className="text-white/50 text-sm">1-800-GOLDNOTE</li>
            </ul>
            
            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors" aria-label="Facebook">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors" aria-label="Instagram">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors" aria-label="Twitter">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="#" className="text-white/40 hover:text-[#D4AF37] transition-colors" aria-label="LinkedIn">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40 tracking-wider">
            &copy; {new Date().getFullYear()} Goldnote Corporation. All rights reserved.
          </p>

          {/* Legal Links */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <Link to="/privacy" className="text-xs text-white/40 hover:text-[#D4AF37] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-xs text-white/40 hover:text-[#D4AF37] transition-colors">Terms of Service</Link>
            <Link to="/cookies" className="text-xs text-white/40 hover:text-[#D4AF37] transition-colors">Cookie Policy</Link>
            <Link to="/disclaimer" className="text-xs text-white/40 hover:text-[#D4AF37] transition-colors">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
